import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SegmentListLayer from "../../components/TradingSettings/SegmentListLayer";

const SegmentListPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Segment Management" />
      <SegmentListLayer />
    </MasterLayout>
  );
};

export default SegmentListPage;
